import * as React from 'react';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { ClientsLoginSettingsData, SelfSchedulingSettingsData } from '../../../models';
import { Alert } from 'reactstrap';
import { CheckInputField } from '../../../components/Forms/fields/CheckInputField';

interface ClientsPortalTabProps {
    id: string;
    values: ClientsLoginSettingsData;
    onSelfSchedulingChanged: (selfScheduling: Partial<SelfSchedulingSettingsData>) => void;
}

export const ClientsPortalTab: React.FC<ClientsPortalTabProps> = ({ id, values, onSelfSchedulingChanged }) => {
    const t = useTranslations();

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-M)'}}>
            <Alert color="info" isOpen>
                {t(TK.clientsPortalDescription)}
            </Alert>

            {/* TECH DEBT: selfScheduling.Enabled does NOT control portal access.
                The real portal on/off switch is ClientsLogin.Enabled (the outer "Permitir acesso de clientes" checkbox).
                selfScheduling.Enabled is only checked by: Mintu AI plugins (ProfessionalsPlugin, AppointmentsPlugin)
                and RemindersService (pending-approval emails). The actual appointment scheduling endpoint
                (AppointmentsService) and the client portal public data (CompanyPublicDataService) do not check it.
                The invite link in the client form is gated by FeatureEnum.ClientsLogin, which is included in all
                subscription plans and cannot be toggled by the tenant.
                This checkbox should either be removed from this tab, or the backend should be updated to enforce it
                as a true portal scheduling gate. */}
            <CheckInputField
                id={`${id}-client-self-scheduling-enabled`}
                label={t(TK.allowClientsSelfScheduling)}
                value={values?.selfScheduling?.enabled}
                onChange={enabled => onSelfSchedulingChanged({enabled})}/>

            {values?.selfScheduling?.enabled &&
                <CheckInputField
                    id={`${id}-allow-share-documents`}
                    label={t(TK.allowShareDocumentsWithClients)}
                    helpText={t(TK.allowShareDocumentsWithClientsTooltip)}
                    value={values?.selfScheduling?.allowShareDocumentsWithClients}
                    onChange={allowShareDocumentsWithClients => onSelfSchedulingChanged({allowShareDocumentsWithClients})}/>
            }
        </div>
    );
};
